module.exports = __webpack_public_path__ + "static/media/bobdouglas.d1307bb8.jpg";